"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Definition of user open component
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOpenComponentParameters = void 0;
exports.UserOpenComponentParameters = [
    {
        id: 'max',
        label: 'Maximum Value',
        description: 'Input Param - The maximum number of elements allowed',
        type: 'int',
        required: false,
        paramType: 'INT',
    },
    {
        id: 'output',
        label: 'Output Value',
        description: 'Output Param - The array of media elements provided by the user',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserOpenComponent.js.map